import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BottomNav } from "@/components/BottomNav";
import { Spinner } from "@/components/common";

export function Protected({ children, tab = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen bg-background"><Spinner label="Loading FlatTribe…" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded && location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return (
    <div className="min-h-screen bg-background">
      <div className={tab ? "pb-24" : ""}>{children}</div>
      {tab && <BottomNav />}
    </div>
  );
}
